// import React, { useState, useEffect, useRef } from 'react';

// const TranslateButton = (props) => {
//     const [isSpanish, setIsSpanish] = useState(false);
//     const [scriptAdded, setScriptAdded] = useState(false);
//     const [count, setCount] = useState(0);

//     const googleTranslateElementInit = () => {
//         new window.google.translate.TranslateElement(
//             {
//                 pageLanguage: `${props.lg}`,
//                 includedLanguages: 'es,en',
//                 layout: google.translate.TranslateElement.InlineLayout.TEXT,
//                 autoDisplay: false
//             },
//             "google_translate_element"
//         );


//             // If the prop says we want Spanish, trigger the translation after a short delay.
//         if (props.lg === 'es') {
//             // Delay ensures that the widget is mounted and ready.
//             setTimeout(() => {
//                 const combo = document.querySelector('.goog-te-combo');
//                 if (combo) {
//                     combo.value = 'es';
//                     // Dispatch a change event so the widget picks up the new value.
//                     combo.dispatchEvent(new Event('change'));
//                 }
//             }, 500);
//         }
//     };

//     console.log("props.lg", props.lg);



//     useEffect(() => {
//         if (!scriptAdded) {
//             const myTranslateScript = document.querySelectorAll(
//                 'script[src="//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"]'
//             );

//             if (myTranslateScript.length < 1) {
//                 const addScript = document.createElement("script");
//                 addScript.setAttribute(
//                     "src",
//                     "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
//                 );

//                 document.body?.appendChild(addScript);
//                 window.googleTranslateElementInit = googleTranslateElementInit;

//                 setScriptAdded(true);
//             }
//         }

//         // Cleanup script on unmount
//         return () => {
//             const script = document.querySelector(
//                 'script[src="//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"]'
//             );
//             if (script) {
//                 document.body.removeChild(script);
//             }
//         };
//     }, [scriptAdded]);

//     useEffect(() => {
//         if (count % 2 === 0 && count !== 0) {
//             location.reload();
//         }
//     }, [count])

//     const toggleTranslation = () => {
//         const newLang = isSpanish ? 'en' : 'es';
//         setIsSpanish(!isSpanish);
//         translatePage(newLang);
//         triggerHtmlEvent(document.querySelector('.goog-te-combo'), 'change');
//         setCount(prev => prev + 1);
//     };


//     const triggerHtmlEvent = (element, eventName) => {
//         let event;
//         if (document.createEvent) {
//             event = document.createEvent('HTMLEvents');
//             event.initEvent(eventName, true, true);
//             element.dispatchEvent(event);
//         } else {
//             event = document.createEventObject();
//             event.eventType = eventName;
//             element.fireEvent('on' + event.eventType, event);
//         }
//     };

//     const translatePage = (newLang) => {
//         if (document.querySelector('.goog-te-combo') == undefined) {
//             if (window.location.pathname == "/") {
//                 window.location.reload()
//             }
//         } else {
//             document.querySelector('.goog-te-combo').value = newLang;
//         }
//     };


//     return (
//         <div className={`cursor-pointer ${props.parentClass}`} onClick={toggleTranslation} id="translate-btn-dashboard-design">
//             <div id="google_translate_element" className="hidden"></div>
//             <button
//                 className={`${props.className}`}
//             // disabled={!scriptAdded}
//             >
//                 <img
//                     src={
//                         isSpanish
//                             ? 'https://res.cloudinary.com/drlcisipo/image/upload/v1714663084/English_1_z3fa77.png'
//                             : 'https://res.cloudinary.com/drlcisipo/image/upload/v1713288601/Website%20images/Spanish_2_oaawih.svg'
//                     }
//                     alt="Spanish Flag"
//                     className="w-7 h-7"
//                 />
//                 <span className={`${props.textClassName} notranslate`}>
//                     {isSpanish ? 'ENG' : 'ESP'}
//                 </span>
//             </button>
//         </div>
//     );
// };

// export default TranslateButton;


import React, { useState, useEffect } from 'react';
import { saveIntoServerCache } from '../../utils/saveIntoCache';
import { dispatchT_Language } from '../../Redux/ActionCreator';
import { useDispatch } from 'react-redux';

const TranslateButton = ({ lg, parentClass = '', className = '', textClassName = '' }) => {
  const dispatch = useDispatch();
  // Here we treat "isTranslated" as true when the page is in Spanish.
  // If the incoming prop lg is "es" then we want the page translated.
  const [isTranslated, setIsTranslated] = useState(lg === 'es');
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const [count, setCount] = useState(0);

  // This function is called by the Google Translate script (via the cb parameter)
  const googleTranslateElementInit = () => {
    /* 
      IMPORTANT: The pageLanguage should be set to the language your page is written in.
      In this example, we assume the content is in English.
    */
    new window.google.translate.TranslateElement(
      {
        pageLanguage: 'en',
        includedLanguages: 'en,es',
        layout: window.google.translate.TranslateElement.InlineLayout.TEXT,
        autoDisplay: false,
      },
      'google_translate_element'
    );

    // If the prop says we want Spanish, trigger the translation after a short delay.
    if (lg === 'es') {
      // Delay ensures that the widget is mounted and ready.
      setTimeout(() => {
        const combo = document.querySelector('.goog-te-combo');
        if (combo) {
          combo.value = 'es';
          // Dispatch a change event so the widget picks up the new value.
          combo.dispatchEvent(new Event('change'));
        }
      }, 300);
    }
  };

  useEffect(() => {
      if (count % 2 === 0 && count !== 0) {
        localStorage.setItem("Tcount", 0);
        location.reload();
      }
      
    let tCount = localStorage.getItem("Tcount");
    if (tCount == 0) {
      localStorage.setItem("translateLang", "English");
      saveIntoServerCache("Language", "English");
      dispatch(dispatchT_Language("English"));
    } else if (tCount > 0) {
      localStorage.setItem("translateLang", "Spanish");
      saveIntoServerCache("Language", "Spanish");
      dispatch(dispatchT_Language("Spanish"));
    }
  }, [count]);

  // Load the Google Translate script only once
  useEffect(() => {
    if (!scriptLoaded) {
      // Create the script only if it isn’t already in the document.
      if (!document.querySelector('script[src="//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"]')) {
        const script = document.createElement('script');
        script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
        document.body.appendChild(script);
        // Set the global callback that Google Translate will call once loaded.
        window.googleTranslateElementInit = googleTranslateElementInit;
        setScriptLoaded(true);
      }
    }
    // Optional cleanup: remove the script on unmount.
    return () => {
      const script = document.querySelector('script[src="//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"]');
      if (script) {
        script.remove();
      }
    };
  }, [scriptLoaded, lg]);

  // Toggle function so that users can switch the translation on demand.
  const toggleTranslation = () => {
    const newLang = isTranslated ? 'en' : 'es';
    setIsTranslated(!isTranslated);
    const combo = document.querySelector('.goog-te-combo');
    if (combo) {
      combo.value = newLang;
      combo.dispatchEvent(new Event('change'));
    }
    setCount(prev => prev + 1);
    let tcount = localStorage.getItem("Tcount");
    if (tcount == null) {
      localStorage.setItem("Tcount", 1);
    } else {
      if (tcount < 2) {
        localStorage.setItem("Tcount", parseInt(tcount) + 1);
      } else {
        localStorage.setItem("Tcount", 0);
        setCount(2);
      }
    }
  };

  return (
    <div className={`cursor-pointer ${parentClass}`} onClick={toggleTranslation} id="translate-btn-dashboard-design">
      {/* The google_translate_element container must be rendered even if hidden */}
      <div id="google_translate_element" style={{ display: 'none' }}></div>
      <button className={className}>
        <img
          src={
            isTranslated
              ? 'https://res.cloudinary.com/drlcisipo/image/upload/v1714663084/English_1_z3fa77.png'
              : 'https://res.cloudinary.com/drlcisipo/image/upload/v1713288601/Website%20images/Spanish_2_oaawih.svg'
          }
          alt="Flag Icon"
          className="w-7 h-7"
        />
        <span className={`${textClassName} notranslate`}>
          {isTranslated ? 'ENG' : 'ESP'}
        </span>
      </button>
    </div>
  );
};

export default TranslateButton;
